import React, { useEffect } from 'react';
import CustomAddPage from 'components/custom-pages/CustomAddPage';

const Add = ({ data, handleClick }) => {
  const [initialValues, setInitialValues] = React.useState({
    name: data?.name || '',
  });

  const inputFields = [
    {
      name: 'name',
      label: 'Comapny Name',
      type: 'text',
      required: true,
    },
  ];

  return (
    <CustomAddPage
      pageTitle={data ? 'Update Comapny Master' : 'Add Comapny Master'}
      url={'company-master'}
      action={!data ? 'create' : 'update'}
      updateId={data?._id}
      queryKey="company-master"
      inputFields={inputFields}
      data={initialValues}
      setData={setInitialValues}
      handleClick={handleClick}
    />
  );
};

export default Add;
